import { formatarDinheiro } from '@/nucleo/dinheiro';
import { cn } from '@/nucleo/utilitarios';

interface MoneyDisplayProps {
  /** Valor do banco ("1234.56"), do usuario ("1.234,56") ou em reais. */
  value: string | number | null | undefined;
  /** O que mostrar quando nao ha valor. Padrao: travessao. */
  emptyLabel?: string;
  className?: string;
}

/**
 * Dinheiro em real, sempre por aqui — nunca campo numerico cru
 * (docs/DESIGN-SYSTEM.md, secao 7). Tabular para os valores alinharem em
 * coluna, e sem quebra de linha para "R$ 1.234,56" nao partir no meio.
 */
export function MoneyDisplay({ value, emptyLabel = '—', className }: MoneyDisplayProps) {
  return (
    <span className={cn('font-mono text-sm tabular-nums whitespace-nowrap', className)}>
      {formatarDinheiro(value, emptyLabel)}
    </span>
  );
}
